
import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import avt from "../../assets/images/user/avatar/image-01.jpg";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';

function CRMobileHeader({ handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    return (
        <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
                <div className="mobile-header">
                    <div id="logo" className="logo">
                        <Link to="/">
                            <img className="site-logo" src={logo} alt="Image" />
                        </Link>
                    </div>
                    <Link className="title-button-group" onClick={handleMobile}>
                        <i className="icon-close"></i>
                    </Link>
                </div>


                <div className="content-tab">
                    <div className="nav-wrap">
                        <nav className="main-nav mobile">

                            <ul id="menu-primary-menu" className="menu">
                                {/* <li className="menu-item d-flex align-items-center">
                                    <DashboardSharpIcon />
                                    <Link to="/Dashboard" className="ms-2">Dashboard</Link>
                                </li> */}
                                <li className="menu-item d-flex align-items-center">
                                    <WorkHistorySharpIcon />
                                    <Link to="/Candidates" className="ms-2">Candidates</Link>
                                </li>
                                <li className="menu-item  menu-item-has-children-mobile">
                                    <div className="d-flex align-items-center">

                                        <WorkHistorySharpIcon />
                                        <Link
                                            to="#"
                                            className="iteam-menu ms-2"
                                            onClick={() => {
                                                handleToggle("employers");
                                            }}
                                        >
                                            Manage Job
                                        </Link>
                                    </div>
                                    <Collapse isOpened={toggle.key === "employers"}>
                                        <ul
                                            className="sub-menu-mobile ms-2"
                                            style={{
                                                display: `${toggle.key === "employers" ? "block" : "none"
                                                    }`,
                                            }}
                                        >

                                            <li className="menu-item d-flex align-items-center">
                                                <WorkSharpIcon />
                                                <Link to="/PostJobs">
                                                    Post Jobs
                                                </Link>
                                            </li>
                                            <li className="menu-item d-flex align-items-center">
                                                <WorkSharpIcon />
                                                <Link to="/ViewJobs">
                                                    View Jobs
                                                </Link>
                                            </li>

                                        </ul>
                                    </Collapse>
                                </li>
                                <li className="menu-item  menu-item-has-children-mobile">
                                    <div className="d-flex align-items-center">

                                        <AssignmentSharpIcon />
                                        <Link
                                            to="#"
                                            className="iteam-menu ms-2"
                                            onClick={() => {
                                                handleToggle("applications");
                                            }}
                                        >
                                            Applications
                                        </Link>
                                    </div>
                                    <Collapse isOpened={toggle.key === "applications"}>
                                        <ul
                                            className="sub-menu-mobile ms-2"
                                            style={{
                                                display: `${toggle.key === "applications" ? "block" : "none"
                                                    }`,
                                            }}
                                        >
                                            <li className="menu-item d-flex align-items-center">
                                                <WorkSharpIcon />
                                                <Link to="/ManageApplications">
                                                    Manage Applications
                                                </Link>
                                            </li>
                                            <li className="menu-item d-flex align-items-center">
                                                <WorkSharpIcon />
                                                <NavLink to="/Interviews">
                                                    Interviews
                                                </NavLink>
                                            </li>

                                        </ul>
                                    </Collapse>
                                </li>


                            </ul>
                        </nav>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default CRMobileHeader;
